import { HTMLAttributes, useEffect, useState } from 'react'
import Script from 'next/script'

import Container from '@/components/base/container'
import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'

type BookingEngineProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title: string
    paragraph: string
    checkbox_label: string
    embed: string
  }>

const BookingEngine = ({
  title,
  paragraph,
  checkbox_label,
  embed,
  className
}: BookingEngineProps) => {
  const [termsChecked, setTermsChecked] = useState(false)

  useEffect(() => {
    if (termsChecked) {
      if (
        typeof window !== 'undefined' &&
        typeof (window as any).iFrameResize === 'function'
      ) {
        ;(window as any).iFrameResize({
          resizedCallback: function () {
            if (window.parent) {
              const iframeId = window.frameElement?.id
              if (iframeId)
                window.parent.postMessage(
                  JSON.stringify({ type: 'scrollToIframe', iframeId }),
                  '*'
                )
            }
          }
        })
      }
    }
  }, [termsChecked])

  return (
    <Container className={cn('bg-white py-[90px]', className)} id="prenota">
      <div className={cn('grid w-full grid-cols-12 gap-gutter', 'md:gap-0')}>
        <div className="col-span-12 flex flex-col gap-10 text-dark md:col-span-8 md:col-start-3">
          {title ? (
            <Typography
              component="h2"
              className="text-[3.6rem] font-light leading-[1]"
            >
              {title}
            </Typography>
          ) : null}
          {paragraph ? (
            <Typography className="leading-[1.6] md:text-[1.8rem]">
              {paragraph}
            </Typography>
          ) : null}
        </div>
        <div className="col-span-12 mt-[4rem] md:col-span-8 md:col-start-3">
          <div className="mx-auto grid gap-y-[1.6rem]">
            <label className="flex items-start space-x-[1rem] text-[#5F6368]">
              <input
                type="checkbox"
                checked={termsChecked}
                className="mt-[0.5rem] h-[1.3rem] w-[1.3rem]"
                onChange={(event) => setTermsChecked(event.target.checked)}
              />
              <Typography>{checkbox_label}</Typography>
            </label>
          </div>
        </div>
        {termsChecked ? (
          <div className="col-span-12 flex flex-col gap-10 md:col-span-8 md:col-start-3">
            <Script
              src="https://www.covermanager.com/js/iframeResizer/iframeResizer.min.js"
              strategy="afterInteractive"
              onLoad={() => {
                if (
                  typeof window !== 'undefined' &&
                  typeof (window as any).iFrameResize === 'function'
                ) {
                  ;(window as any).iFrameResize()
                }
              }}
            />
            <iframe
              id="rebis-restaurant"
              title="Rebis Booking"
              src={embed}
              allow="payment"
              width="100%"
              style={{ width: '1px', minWidth: '100%', border: 'none' }}
            />
          </div>
        ) : null}
      </div>
    </Container>
  )
}

export default BookingEngine
